import {
  SET_ACTIVE_EMPLOYEES,
  SET_STEP_ASSIGNMENTS
} from '../constants'

const initialState = {
  activeEmployees: [],
  StepAssignments: []
}

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ACTIVE_EMPLOYEES:
      return {
        ...state,
        activeEmployees: action.employees
      }
    case SET_STEP_ASSIGNMENTS:
      return {
        ...state,
        StepAssignments: action.StepAssignments
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/assign.js